import * as React from "react";
import Modal from "react-bootstrap/Modal";


interface Props {
    
    
}

const LoadingSpinner = (props: Props) => {
    

    return (
        <Modal
            show={true}
            animation={false}
            centered={true}
            onHide={() => { /* don't allow hide via off-click*/ }}
            size="lg"
            enforceFocus={true}
            style={{ background: "rgb(255,255,255, 0.5)", minHeight: "1000000px" }}
        >
            <div id="wait" style={{ position: 'absolute', width: '100%', height: '100%', margin: "auto", top: "360px", left: "-175px", zIndex: 9999, textAlign: 'center', display: 'block' }}>
                <img src="/Images/demo_wait.gif" width={64} height={64} />
                <br />Loading..
            </div>
        </Modal>
    );
}

export default LoadingSpinner;